const unsupportedVariablesErrorBody = (error) =>
  error?.response?.body || error?.body || error || {};

export const isUnsupportedVariablesError = (error) =>
  ["unsupported_variables", "variables_validation_unavailable"].includes(
    unsupportedVariablesErrorBody(error).code,
  );

export const normalizeUnsupportedVariablesError = (error) => {
  const body = unsupportedVariablesErrorBody(error);
  const tokens = [
    ...(body.unsupported_tokens || []),
    ...(body.context_invalid_tokens || []),
  ];

  return {
    code: body.code,
    validationUnavailable:
      body.code === "variables_validation_unavailable" ||
      !!body.validation_unavailable,
    tokens: [...new Set(tokens)],
    message: body.message,
  };
};
